import React from 'react';
import classNames from 'classnames';
import CircleProgress from 'components/CircleProgress';
import XIcon from 'icons/X.icon';
import { Button } from 'ncoded-component-library';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import {
  getIsFileProcessed,
  UploaderMessageFile,
} from 'hooks/useUploadMessageFile';
import { getMimeTypeByNameExtension } from 'uploadFileUtils';

import './UploadingFile.styles.scss';

type UploadingFileProps = {
  className?: string;
  file: UploaderMessageFile;
  onRemove: () => void;
};

const UploadingFile: React.FC<UploadingFileProps> = (props) => {
  const { className, file, onRemove } = props;

  const { percentage, isFailed, name, type } = file;

  const canRemove = getIsFileProcessed({ percentage, isFailed });

  const classes = classNames('uploading-file', { failed: isFailed }, className);

  return (
    <div className={classes}>
      <MymeTypeIcon mimeType={type || getMimeTypeByNameExtension(name)} />

      <p>{name}</p>

      {canRemove ? (
        <Button variant="icon" icon={XIcon} onClick={onRemove} />
      ) : (
        <CircleProgress value={percentage} />
      )}
    </div>
  );
};

export default UploadingFile;
